import { NgModule } from "@angular/core";

import { ObgMatTabsScrollDirective } from "./mat-tabs-scroll.directive";

const DIRECTIVES = [ObgMatTabsScrollDirective];

@NgModule({
	imports: [],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class ObgMatTabsScrollModule {}
